import React from 'react';

export interface SlurmJobMetadata {
  numNodes?: string;
  partition?: string;
  name?: string;
  cluster?: string;
  account?: string;
  qos?: string;
  user?: string;
  nodelist?: string;
  submitDir?: string;
  cpusPerTask?: string;
  memPerCpu?: string;
  startTime?: string;
  endTime?: string;
}

export function MetadataRow({
  label,
  value,
}: {
  label: string;
  value?: React.ReactNode;
}) {
  return (
    <div className="grid min-h-36 grid-cols-[156px_1fr] items-center gap-8 pl-16 pr-12">
      <div className="whitespace-nowrap text-base font-semibold text-moon-600 dark:text-wb-text-secondary">
        {label}
      </div>
      <div className="min-w-0 rounded px-12 text-base text-wb-text-primary dark:text-moon-200">
        {value ?? '-'}
      </div>
    </div>
  );
}
